<template></template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    async logout() {
      await this.$store.dispatch('logout');
      this.$router.push('/');
    },
  },
  mounted() {
    this.logout();
  },
});
</script>
